import type { Dispatch, SetStateAction } from 'react';
import { getCharacterStats } from '../../../domain/CharacterStats';
import type { CharacterNameId } from '../components/atomic/character/character_names/CharacterName';
import {
  CHARACTER_ORDER,
  type CharacterIconId,
} from './characters_icon/CharacterIcon';

export type SelectCharacterScreenProps = {
  onConfirm?: (characterId: CharacterIconId) => void;
  onGoBack?: () => void;
};

export const HORIZONTAL_ARROW_POSITIONS = {
  left: { left: 55.9609, top: 740.2686 },
  right: { left: 946.1934, top: 740.283 },
} as const;

export const CHARACTER_NAMES_LAYOUT: Record<
  CharacterNameId,
  { left: number; top: number; width: number; height: number; rotation: number }
> = {
  tuchi: {
    left: 141.3639,
    top: 416.8977,
    width: 274.5331,
    height: 223.5093,
    rotation: -31.28,
  },
  claudi: {
    left: 161.5033,
    top: 434.1468,
    width: 329.547,
    height: 191.118,
    rotation: -20.08,
  },
  eddy: {
    left: 414.2969,
    top: 428.6738,
    width: 199.5351,
    height: 131.6694,
    rotation: 4.85,
  },
  rock: {
    left: 619.274,
    top: 450.3682,
    width: 186.2921,
    height: 163.0384,
    rotation: 33.45,
  },
  ufo: {
    left: 617.6707,
    top: 457.1165,
    width: 219.731,
    height: 140.7468,
    rotation: 18.26,
  },
  vall: {
    left: 706.7146,
    top: 462.2892,
    width: 227.7218,
    height: 129.8277,
    rotation: -4.44,
  },
};

export type SelectCharacterScreenState = {
  selectedIndex: number;
  setSelectedIndex: Dispatch<SetStateAction<number>>;
};

export type SelectCharacterScreenModel = {
  selectedIndex: number;
  setSelectedIndex: Dispatch<SetStateAction<number>>;
  selectedCharacter: CharacterIconId;
  totalCharacters: number;
  nameLayout: {
    left: number;
    top: number;
    width: number;
    height: number;
    rotation: number;
  };
  stats: ReturnType<typeof getCharacterStats>;
  onConfirm?: (characterId: CharacterIconId) => void;
  onGoBack?: () => void;
};

export function createSelectCharacterScreenModel(
  props: SelectCharacterScreenProps,
  state: SelectCharacterScreenState,
): SelectCharacterScreenModel {
  const selectedCharacter = CHARACTER_ORDER[state.selectedIndex] as CharacterIconId;

  return {
    selectedIndex: state.selectedIndex,
    setSelectedIndex: state.setSelectedIndex,
    selectedCharacter,
    totalCharacters: CHARACTER_ORDER.length,
    nameLayout: CHARACTER_NAMES_LAYOUT[selectedCharacter],
    stats: getCharacterStats(selectedCharacter),
    onConfirm: props.onConfirm,
    onGoBack: props.onGoBack,
  };
}
